import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { linkify } from 'src/app/common/app.helpers';
import AppValues from 'src/app/common/app.values';
import FieldsConstants from 'src/app/common/fields.constants';
import { CommentPosition, LoadedCommentsState } from 'src/app/interfaces/posts.interface';
import { DialogMessagePlaceholders } from 'src/app/notifications/dialogs/dialog-message/dialog-message-placeholders.model';
import { ConversationForm } from '../conversation-form.abstract';

@Component({
  selector: 'app-commentary-form-field',
  templateUrl: '../conversation-form.component.html',
  styleUrls: ['../conversation-form.component.scss'],
})
export class CommentaryFormFieldComponent extends ConversationForm implements OnInit, OnChanges {
  @Input({ required: true }) public indexLabel: string;
  @Input({ required: true }) public loadedComments: LoadedCommentsState;
  @Input({ required: true }) public placeholderPhrases: DialogMessagePlaceholders;

  @Input({ required: false }) public memberTypingName = '';
  @Input({ required: false }) public isReadOnly = false;
  @Input({ required: false }) public counterVisibility = false;
  @Input({ required: false }) public userAvatarVisibility = false;
  @Input({ required: false }) public maxLength: number = FieldsConstants.MAX_COMMENT_LENGTH;
  @Input({ required: false }) public commentPosition: CommentPosition | null = null;

  @Output() public sendTextMessage: EventEmitter<string> = new EventEmitter<string>();
  @Output() public hideReply: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('inputMessage', { static: false }) public inputMessageRef: ElementRef<HTMLElement>;

  public ngOnChanges(): void {
    if (this.commentPosition && this.loadedComments) {
      this.onReplyComment();
    }
  }

  public onReplyComment(): void {
    this.createForm();

    setTimeout(() => {
      this.inputMessageRef.nativeElement.focus();
    });
  }

  public submitMessage(): void {
    if (this.messageInput.value) {
      this.messageInput.patchValue(linkify(this.messageInput.value.trim()));
    }

    if (this.messageForm.invalid || !this.messageInput.value) {
      return;
    }

    this.sendTextMessage.emit(this.messageInput.value);
    this.dirtyForm.emit(false);

    this.messageForm.reset();
  }

  public getValidationError(): string {
    if (!this.messageInput || !this.messageInput.errors) {
      return '';
    }

    if (this.messageInput.errors['pattern']) {
      return this.placeholderPhrases.emptyErrorHint;
    }

    if (this.messageInput.errors['maxlength']) {
      return this.placeholderPhrases.maxLengthErrorHint;
    }

    return '';
  }

  /**
   * @description On press the escape key clears the form.
   * @param { KeyboardEvent } event
   */
  public onKeyUpEvent(event: KeyboardEvent): void {
    if (event.code === AppValues.KEYCODE_ESCAPE) {
      this.inputMessageRef.nativeElement.blur();
      this.messageForm.reset();
      this.hideReply.emit();
    }
  }

  protected getMaxLengthConstraint(): number {
    return this.maxLength;
  }
}
